module.exports = __webpack_public_path__ + "c70e824e.png";